import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=bf69478e&scoped=true&"
import script from "./DetailOrder.vue?vue&type=script&lang=js&"
export * from "./DetailOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrder.vue?vue&type=style&index=0&id=bf69478e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf69478e",
  null
  
)

export default component.exports